import React, { useState } from "react";
import LiveData from "./LiveData";

const All = () => {
  return <LiveData />;
};

export default All;
